module.exports = __webpack_public_path__ + "img/trapezoid.9bdd25c9.svg";